import React from "react";
import styled from "styled-components";
import AppLink from "components/common/style/link/AppLink";
import { PhotoSeries } from "model/photo_series/PhotoSeries";

type PhotoSeriesEditNavProps = {
  photoSer: PhotoSeries;
};

const PhotoSeriesEditNav = ({ photoSer }: PhotoSeriesEditNavProps) => {
  const photoSerId = photoSer.id;

  return (
    <DivEditNav>
      <AppLink to={`/admin-dashboard/photo-ser-edit/${photoSerId}`}>
        polja
      </AppLink>
      <AppLink to={`/admin-dashboard/photo-ser-edit/${photoSerId}/photo`}>
        photo
      </AppLink>
    </DivEditNav>
  );
};

export default PhotoSeriesEditNav;

const DivEditNav = styled.div`
  display: flex;
  gap: 1rem;
`;
